import { render, staticRenderFns } from "./UserAttributes.vue?vue&type=template&id=50a7d6ca&"
import script from "./UserAttributes.vue?vue&type=script&lang=js&"
export * from "./UserAttributes.vue?vue&type=script&lang=js&"
import style0 from "./UserAttributes.vue?vue&type=style&index=0&id=50a7d6ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports